<div class="huddle-action-top-panel">
  <div class="huddle-action-control-panel">
    <div class="huddle-action-left-control">
      <p class="tab-description">
        Track all action plans with problem statements, themes, ownership, actions taken, and current status.
      </p>
    </div>
    <div class="huddle-action-right-control">
      <div class="litmus-action-filter-dd" #litmusfeedsearch id="litmusfeedsearch"
        *ngIf="isSearchEnabled && defaultSearchField">
        <div class="litmus-action-filter-dd-input" [class.active]="showFilterFields">
          <img class="search-icon" src="assets/images/magnify.svg">
          <input type="text" (keyup)="searchByField($event)" [(ngModel)]="searchText" (click)="toggleSearchList()"
            [placeholder]="actionSearch.placeholder" />
          <button *ngIf="clearField.isEnabled" class="clear-button" (click)="getActionsforSelectedFields(clearField)">
            <img class="clear-img" src="assets/images/close.svg">
          </button>
          <button (click)="toggleFilterFieldList()" class="field-dropdown-button" [class.active]="showFilterFields">
            <img src="assets/images/menu-down-dark.svg" />
          </button>
        </div>
        <ul id="litmus-search-selector" *ngIf="isOptionLoading" class="litmus-action-filter-dd-list">
          <li class="loader">
            <span class="circle-loader"></span> Just a moment.
          </li>
        </ul>
        <ul id="litmus-search-list" *ngIf="showSearchList && !isOptionLoading" class="litmus-action-filter-dd-list">
          <li *ngFor="let item of searchResult.options" [class.disabled-message]="item.isError"
            (click)="getActionsforSelectedFields(item)">
            {{item.displayText || item.text}}
          </li>
        </ul>
        <ul id="litmus-search-selector" *ngIf="showFilterFields" class="litmus-action-filter-dd-list">
          <li *ngFor="let item of searchableFieldList" (click)="changeFilterField(item)"
            [class.active]=" item.field_id == defaultSearchField.field_id">
            {{item.name}}
          </li>
        </ul>
      </div>
      <div class="widget-container">
        <div class="download-button" (click)="actionResponseDownload()">
          <span ><img class="opacity" src="assets/images/download.svg"></span>
        </div>
       <!-- <div class="divider"></div>
        <div class="fullscreen-button" (click)="toggleFullScreen()" >
          <span ><img src="assets/images/fullscreen-exit.svg"></span>
        </div> -->
      </div>
      <div class="paging-holder">
        <!-- This is used for Pagination -->
        <div class="litmus-action-paging">
          <button [disabled]="!pagingButtons.isFirst || isLoading" (click)="paginateFeedList('first')">
            <img src="assets/images/chevron-double-left.svg" />
          </button>
          <button [disabled]="!pagingButtons.isPrevious || isLoading" (click)="paginateFeedList('previous')">
            <img src="assets/images/chevron-left.svg" />
          </button>
          <span [class.disabled]="pagingDetails.total <= 0"> {{pagingDetails.start}} - {{pagingDetails.end}}
            of {{pagingDetails.total}} </span>
          <button [disabled]="!pagingButtons.isNext || isLoading" (click)="paginateFeedList('next')">
            <img src="assets/images/chevron-right.svg" />
          </button>
          <button [disabled]="!pagingButtons.isLast || isLoading" (click)="paginateFeedList('last')">
            <img src="assets/images/chevron-double-right.svg" />
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!isLoading && isDataAvailable" class="table-holder">
  <app-overview-table [config]="tableConfigs" [columns]="actionTable.header" [fixedColumns]="actionTable.fixedHeader"
    (onDataSort)="getSortedData($event)" (onEdit)="editActionDetail($event)"
    [rows]="actionTable.rows"></app-overview-table>
</div>
<div *ngIf="!isLoading && !isDataAvailable" class="table-holder">
  <app-ltms-error [code]="'404'"></app-ltms-error>
</div>
<div *ngIf="isLoading">
  <div class="d-flex align-items-center justify-content-center" style="min-height: 15rem">
    <div role="status">
      <app-ltms-loader></app-ltms-loader>
    </div>
  </div>
</div>
<action-edit-modal *ngIf="showEditModal" (onClose)="closeEditModal()" (onCancel)="cancelEdit()"
  (onUpdate)="reloadActionList($event)" [configs]="modalData"></action-edit-modal>